var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('div',{staticClass:"rectangle"},[_c('svg-icon',{staticStyle:{"margin":"0 8px 0 15px"},attrs:{"icon":"tags"}}),_c('span',{staticClass:"title-span"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])],1),_c('div',{staticClass:"triangle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }